// @flow

/**
 * Preload image to cache on the client
 * @param {string} url - URL of image to preload
 */
export function preloadImage(url: string) {
  if (url && typeof url === 'string') {
    const image = new Image()
    image.src = url
  }
}
